
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'


export default {
components: {
XHeader,
XInput,
XButton,
Group,
Toast
},
name: 'ResetPwd',
data () {
return {
disable: false,
showToast: false,
message: '',
old_password: '',
new_password: '',
new_password_confirm: ''
}
},
methods: {
doSubmit () {
this.disable = true
this.$vux.loading.show({
text: '加载中...'
})
this.$store.dispatch('resetSellerPwd', {
old_password: this.old_password,
new_password: this.new_password,
new_password_confirm: this.new_password_confirm
}).then((res) => {
const status = res.status
if (status > 0) {
this.$vux.toast.text('密码更新成功', 'top')

this.showToast = true
this.$router.push({path: '/user/index'})
} else {
this.message = res.msg
this.showToast = true
this.disable = false
}
this.$vux.loading.hide()
}).catch((err) => {
console.log(err)
this.disable = false
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/user/ResetPwd.vue